/**
 * @deprecated
 * Use native Symbol.iterator instead
 */
export function getSymbolIterator(): string | symbol {
    return Symbol.iterator;
}
